export default "__VITE_ASSET__ea0ac5bb__"